import * as yup from 'yup'

import { ShippingOptions } from '../../_gen/gql'

import { Address, PartRequestInput } from '../../../types'

const PartRequestSchema = yup.object({
  mpn: yup
    .string()
    .when('description', {
      is: (description) => !description,
      then: (schema) => schema.required('Part Number or Description is required'),
      otherwise: (schema) => schema,
    })
    .label('Part Number'),
  description: yup.string().optional().label('Description'),
  quantity: yup.number().required().typeError('${label} must be a ${type}').label('Quantity'),
})

const CreateRfqFormSchema = yup.object({
  name: yup.string().required().label('Name'),
  email: yup.string().required().label('Email'),
  phoneNumber: yup.string().required().label('Phone Number'),
  engineHours: yup.string().optional().label('Engine Hours'),
  onBehalfOfUserId: yup.string().required().label('On Behalf Of'),
  code: yup.string(),
  partsRequest: yup.string().optional().label('Additional Details'),
  vendorIds: yup.array().of(yup.string()).ensure().label('Vendors List'),
  shippingLocationIds: yup.array().of(yup.string()).ensure().label('Shipping Location'),
  accountMachineId: yup.string().required().label('Machine'),
  shippingAddress: yup.object().required().label('Shipping Address'),
  shippingOption: yup
    .string()
    .oneOf([
      ShippingOptions.Expedited,
      ShippingOptions.Overnight,
      ShippingOptions.Standard,
      ShippingOptions.None,
    ])
    .label('Shipping Option'),
  categoryId: yup.string().nullable().optional().label('Category'),
  partRequestInputs: yup.array().of(PartRequestSchema).required().min(1).label('Parts List'),
})

export type CreateRfqForm = {
  onBehalfOfUserId: string
  name: string
  email: string
  phoneNumber: string
  engineHours: string
  code: ''
  partsRequest: string
  vendorIds: string[]
  shippingLocationIds: string[]
  accountMachineId?: string
  shippingAddress?: Address
  shippingOption: ShippingOptions
  categoryId: string | null
  partRequestInputs: PartRequestInput[]
}

export { CreateRfqFormSchema }
